import { createFileRoute } from '@tanstack/react-router';
import OrderListView from '../admin/orders/list-view';
export const Route = createFileRoute('/admin/order/list')({ component: OrderListView });
